export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/participation/var',
		name: 'NbuParticipationVar',
		title: {
			single: 'NbuParticipationVar',
			plural: 'NbuParticipationVars'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "1",
				"code": null,
				"name": "Самостійно",
				"caption": "Самостійно",
				"isBlocked": false
			},
			{
				"id": "2",
				"code": null,
				"name": "Спільно з іншими особами",
				"caption": "Спільно з іншими особами",
				"isBlocked": false
			},
			{
				"id": "3",
				"code": null,
				"name": "Самостійно/Спільно з іншими особами",
				"caption": "Самостійно/Спільно з іншими особами",
				"isBlocked": false
			}
		],
	},
}
